import get from 'lodash/fp/get'
import { call } from 'redux-saga/effects'
import { createRoutineSaga, SAGA_WATCHER_LATEST_MODE } from '../../utils/saga'
import injectSaga from '../../state/hoc/injectSaga'

import { switchLocaleRoutine } from './routines'
import intlLoader from './intlLoader'

export function * switchLocaleSaga(locale) {
  const result = yield call(intlLoader, locale)

  return { locale, ...result }
}

export const { watcher, saga } = createRoutineSaga({
  routine: switchLocaleRoutine,
  requestSaga: switchLocaleSaga,
  requestArgsCreator: get('payload'),
  watcherMode: SAGA_WATCHER_LATEST_MODE
})

export const withSaga = injectSaga({ key: 'intl', saga: watcher })
